// extracted by mini-css-extract-plugin
export default {"errorId":"Gg"};